export enum AuthActionTypes {
  TOGGLE_MODAL = 'TOGGLE_MODAL',
  SET_MODAL_STATE = 'SET_MODAL_STATE',
  INPUT_EMAIL = 'INPUT_EMAIL',
  INPUT_PASSWORD = 'INPUT_PASSWORD',
  SHOW_PASSWORD = 'SHOW_PASSWORD',
  INPUT_CODE = 'INPUT_CODE',
  REPEAT_NEW_PASSWORD = 'REPEAT_NEW_PASSWORD',
}

export interface ToggleModal {
  type: AuthActionTypes.TOGGLE_MODAL;
  isModalOpen: boolean;
}

export interface SetModalState {
  type: AuthActionTypes.SET_MODAL_STATE;
  modalState: string;
  isPrev?: boolean;
}

export interface InputPassword {
  type: AuthActionTypes.INPUT_PASSWORD;
  password: string;
}

export interface InputCode {
  type: AuthActionTypes.INPUT_CODE;
  code: string;
}

export interface ShowPassword {
  type: AuthActionTypes.SHOW_PASSWORD;
}

export interface RepeatNewPassword {
  type: AuthActionTypes.REPEAT_NEW_PASSWORD;
  newPassword: string;
}

export type AuthActions = ToggleModal | SetModalState | InputPassword | InputCode | ShowPassword | RepeatNewPassword;

export function toggleModal() {
  return {
    type: AuthActionTypes.TOGGLE_MODAL,
  };
}

export function setModalState(modalState: string, isPrev?: boolean): SetModalState {
  return {
    type: AuthActionTypes.SET_MODAL_STATE,
    modalState,
    isPrev,
  };
}

export function inputPassword(password: string): InputPassword {
  return {
    type: AuthActionTypes.INPUT_PASSWORD,
    password,
  };
}

export function inputCode(code: string): InputCode {
  return {
    type: AuthActionTypes.INPUT_CODE,
    code,
  };
}

export function showPassword() {
  return {
    type: AuthActionTypes.SHOW_PASSWORD,
  };
}

export function repeatNewPassword(newPassword: string): RepeatNewPassword {
  return {
    type: AuthActionTypes.REPEAT_NEW_PASSWORD,
    newPassword,
  };
}
